import { Col, Input, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import { t } from "i18next";
import React from "react";
import useEditDataGroup from "./edit-data-group.hooks";

const TabDetailUser = () => {
  const { id, name, desc, onChange, dataGroupNameError, descriptionError, loading } = useEditDataGroup();

  if (!loading) {
    return (
      <>
        <Row className="mt-5 h-[500px]">
          <Col span={12}>
            <div>
              <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                {t("DATA_GROUP:TBL_ID")}
              </p>
              <Input
                style={{ width: "50%" }}
                size="large"
                disabled
                value={id}
                placeholder={t("COMMON:TYPE", {
                  field: t("DATA_GROUP:LBL_DATA_GROUP_NAME"),
                })}
              />
            </div>
            <div>
              <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                {t("DATA_GROUP:LBL_DATA_GROUP_NAME")}
              </p>
              <Input
                style={dataGroupNameError ? { width: '50%', border: '#CF0000 1px solid', borderRadius: '6px' } : { width: '50%' }}
                size="large"
                defaultValue={name}
                onChange={(e) => onChange("dataGroupName", e.target.value)}
                placeholder={t("COMMON:TYPE", {
                  field: t("DATA_GROUP:LBL_DATA_GROUP_NAME"),
                })}
              />
              <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${dataGroupNameError ? `visible` : `hidden`}`}>This field is required</p>
            </div>
            <div className="mt-2">
              <p className=" mb-1 font-roboto-medium text-[16px] text-[#1D1D1D]">
                {t("DATA_GROUP:LBL_DESCRIPTION")}
              </p>
              <TextArea
                style={descriptionError ? { width: '50%', border: '#CF0000 1px solid', borderRadius: '6px' } : { width: '50%' }}
                size="large"
                defaultValue={desc}
                onChange={(e) => onChange("description", e.target.value)}
                placeholder={t("COMMON:TYPE", {
                  field: t("LOGIN_COMPLETION:LBL_ADDRESS"),
                })}
              />
              <p className={`font-[12px] mt-[8px] text-[#FF0000] font-roboto ${descriptionError ? `visible` : `hidden`}`}>This field is required</p>

            </div>
          </Col>
          <Col span={12}></Col>
        </Row>
      </>
    );
  }
};

export default TabDetailUser;
